
import createDOMPurify from 'dompurify';

const DOMPurify = createDOMPurify(window);

export default function trimTags(value) {
    return DOMPurify.sanitize(value, {ALLOWED_TAGS: []})
        .replace(/\&nbsp;/g, '');
}



// WEBPACK FOOTER //
// ./src/components/helpers/trimTags.js